import { GridReducer } from '../../../common/grid/grid.reducer';
import {GridFilterReducer} from '../../../common/grid/filter/grid-filter.reducer';
import * as GRID from '../../../common/grid/grid.constants';
import * as FORM from '../../../common/form/input/input.constants';
import { TYPES } from './adm-categorisation-action-type.constants';
import { IDS } from './adm-categorisation-action-id.constants';
import merge from 'lodash/merge';
import get from 'lodash/get';
import set from 'lodash/set';

/**
 * @function administrationCategorisationReducer
 * @param state {object}
 * @param action {object}
 * @returns {object} Redux Store
 * @memberOf Reducers
 */
export function administrationCategorisationReducer(state = undefined, action = undefined) {

    if (typeof state === 'undefined') {
        return {
            [IDS.admCatCentersGrid]: GridReducer(),
            [IDS.admCatCenterDetails]: {},
            [IDS.admCatCenterModules]: [],

            [IDS.admCatDocumentsGrid]: GridReducer(),
            [IDS.admCatOccupationDetails]: {},

            [IDS.admCatOccupationsGrid]: GridReducer(),
            [IDS.admCatOccupationDetails]: {},

            [IDS.admCatCapabilitiesGrid]: GridReducer(),
            [IDS.admCatCapabilityDetails]: {},
        };
    }

    switch (action.type) {
        case TYPES.CENTER_DETAILS_REFRESH:
            if (action.id === IDS.admCategorisation) {
                return {...state,
                    [IDS.admCatCenterDetails]: {
                        ...action.item,
                        ahpra_licence_required: action.item.ahpra_licence_required === 'Yes' ? 1 : 0,
                        use_licence_required: action.item.use_licence_required === 'Yes' ? 1 : 0,
                    }
                };
            }
            return state;
        case TYPES.FETCH_CENTER_TYPE_MODULES:
            if (action.id === IDS.admCategorisation) {
                return {...state,
                    [IDS.admCatCenterModules]: action.data
                };
            }
            return state;
        // case TYPES.OCCUPATION_DETAILS_REFRESH:
        //     if (action.id === IDS.admCategorisation) {
        //         return {...state,
        //             [IDS.admCatOccupationDetails]: action.item
        //         };
        //     }
        //     return state;
        // case TYPES.CAPABILITY_DETAILS_REFRESH:
        //     if (action.id === IDS.admCategorisation) {
        //         return {...state,
        //             [IDS.admCatCapabilityDetails]: action.item
        //         };
        //     }
        //     return state;
        case 'INPUT_SELECT':
        case 'INPUT_TEXT_CHANGE':
        case 'INPUT_TEXT_AREA_CHANGE':
        case 'INPUT_EMAIL_CHANGE':
        case 'CHECKBOX_SELECTED':
        case 'INPUT_RADIO_CHANGE':
            if (action.id === IDS.admCategorisation) {
                return set({...state}, action.path, action.input);
            }
            return state;
        case GRID.GRID_RESET:
            if (action.id === IDS.admCategorisation) {
                state = set({...state} ,`${action.path}.filter`,  GridFilterReducer());
            }

        case GRID.GRID_INIT:
        case GRID.GRID_FILTER:
        case GRID.GRID_FILTER_TOGGLE:
        case GRID.GRID_RESET_FILTER:
        case GRID.GRID_INIT_FILTER:
        case GRID.GRID_LOADING:
        case GRID.GRID_PAGINATE:
        case GRID.GRID_RELOAD:
        case GRID.GRID_FETCH:
        case GRID.GRID_SELECT:
        case GRID.GRID_SELECT_ALL:
        case GRID.GRID_DESELECT:
        case GRID.GRID_DESELECT_ALL:
            if(action.id === IDS.admCategorisation) {
                return {...state,
                    [action.path]: GridReducer(get(state, action.path), action)
                };
            }
        case FORM.INPUT_SELECT:
        case FORM.INPUT_TEXT:
        case FORM.INPUT_TEXT_AREA:
        case FORM.INPUT_CHECKBOX:
        case FORM.INPUT_DATE:
        case FORM.INPUT_RADIO:
            if (action.id === IDS.admCategorisation) {

                if(action.path.startsWith(IDS.admCatCentersGrid)) {
                    const filter = {
                        [action.path.split('.').pop()]: action.input
                    };
                    action.path = IDS.admCatCentersGrid;
                    return set({...state}, action.path,
                        GridReducer(get(state, action.path), { type: GRID.GRID_FILTER, filter })
                    )
                }
                return set({...state}, action.path, action.input)
            }
        // case 'LOCATION_SELECTED': // slo select-cascade.js
            // if (action.id === IDS.accreditationSettingsHeadOffices) {
                // return set({...state}, 'headOffices.selectedHeadOfficeUuid', action.uuid)
            // }
        default:
            return state;
        }
}
